import React from 'react';
import styled from 'styled-components';
import { Button } from '../../../Button';
import { Flex } from '../../../Flex';
import { IconButton } from '../../../IconButton';
var IconButtonContainer = styled(Flex).attrs({
  justifyContent: 'center',
  alignItems: 'center'
}).withConfig({
  displayName: "InlineAction__IconButtonContainer",
  componentId: "sc-168zfqz-0"
})(["box-sizing:border-box;cursor:pointer;height:40px;width:40px;button{display:flex;justify-content:center;align-items:center;width:32px;height:32px;}"]);
export var InlineAction = function InlineAction(_ref) {
  var action = _ref.action,
      rowData = _ref.rowData;
  var ActionRenderer = action.renderer;
  return ActionRenderer || action.icon ? /*#__PURE__*/React.createElement(IconButtonContainer, {
    onClick: function onClick() {
      return action.onExecute(rowData);
    },
    title: action.label
  }, ActionRenderer ? /*#__PURE__*/React.createElement(ActionRenderer, {
    rowData: rowData
  }) : /*#__PURE__*/React.createElement(IconButton, {
    component: action.icon,
    size: 16,
    discColor: "secondary.lighter"
  })) : /*#__PURE__*/React.createElement(Button, {
    mode: "link",
    size: "small",
    onClick: function onClick() {
      return action.onExecute(rowData);
    }
  }, action.label);
};